import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class ProductApplicationIdNotSetException extends  QuoteException {

}